(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9667,7665],{

/***/ 37665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B3": function() { return /* binding */ confirmSponsorApproval; },
/* harmony export */   "BV": function() { return /* binding */ markReraw; },
/* harmony export */   "NB": function() { return /* binding */ unpublishStory; },
/* harmony export */   "NI": function() { return /* binding */ setAlertNoindex; },
/* harmony export */   "To": function() { return /* binding */ markNotRaw; },
/* harmony export */   "Ui": function() { return /* binding */ fetchAuthors; },
/* harmony export */   "W3": function() { return /* binding */ publishStory; },
/* harmony export */   "Wu": function() { return /* binding */ uploadSponsorLogo; },
/* harmony export */   "Xl": function() { return /* binding */ markRaw; },
/* harmony export */   "Yo": function() { return /* binding */ sendStoryOffer; },
/* harmony export */   "_H": function() { return /* binding */ withdrawSponsorApproval; },
/* harmony export */   "aL": function() { return /* binding */ fetchNews; },
/* harmony export */   "k$": function() { return /* binding */ fetchStorySponsors; },
/* harmony export */   "mY": function() { return /* binding */ saveStory; },
/* harmony export */   "mh": function() { return /* binding */ fetchProfileBySlug; },
/* harmony export */   "n5": function() { return /* binding */ fetchSponsorProof; },
/* harmony export */   "q6": function() { return /* binding */ uploadLeadImage; },
/* harmony export */   "su": function() { return /* binding */ fetchStory; },
/* harmony export */   "tt": function() { return /* binding */ newsroomError; },
/* harmony export */   "yV": function() { return /* binding */ fetchRawQueue; }
/* harmony export */ });
/* unused harmony export fetchRaws */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);




// Storify / Raw / Publish and the Raws archive. These call the axios instance
// directly (not getReq/postReq) so the API's error message reaches the editor,
// e.g. "Write and save a headline and a story before publishing".
var unwrap = function(res) {
    return res.data.data;
};
var newsroomError = function(err, fallback) {
    var ref, ref1;
    var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if (Array.isArray(message)) return message.join(" ");
    return typeof message === "string" && message ? message : fallback;
};
var fetchStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/".concat(alertId, "/story"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var saveStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, story) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/story"), story)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveStory(alertId, story) {
        return _ref.apply(this, arguments);
    };
}();
// Not fileUpload: its multipart interceptor stays on after a failed request. Axios sets
// the multipart header and boundary itself for FormData.
var formData = function(fields) {
    return Object.entries(fields).reduce(function(form, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        form.append(key, value);
        return form;
    }, new FormData());
};
var _leadImageAlt, _leadImageCaption, _leadImageCredit;
// The API checks the file and makes the 1200px copy and the crops; the story must be saved first.
var uploadLeadImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, file, draft) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/lead-image"), formData({
                            image: file,
                            leadImageAlt: (_leadImageAlt = draft.leadImageAlt) !== null && _leadImageAlt !== void 0 ? _leadImageAlt : "",
                            leadImageCaption: (_leadImageCaption = draft.leadImageCaption) !== null && _leadImageCaption !== void 0 ? _leadImageCaption : "",
                            leadImageCredit: (_leadImageCredit = draft.leadImageCredit) !== null && _leadImageCredit !== void 0 ? _leadImageCredit : ""
                        }))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function uploadLeadImage(alertId, file, draft) {
        return _ref.apply(this, arguments);
    };
}();
var uploadSponsorLogo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, file) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/sponsor-logo"), formData({
                            file: file
                        }))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ]).url
                    ];
            }
        });
    });
    return function uploadSponsorLogo(alertId, file) {
        return _ref.apply(this, arguments);
    };
}();
// bannerHash is the banner the admin is looking at; the API refuses with 409 if
// the stored one has changed since.
var confirmSponsorApproval = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, file, bannerHash) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/sponsor-approval"), formData({
                            file: file,
                            confirmed: "true",
                            bannerHash: bannerHash !== null && bannerHash !== void 0 ? bannerHash : ""
                        }))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function confirmSponsorApproval(alertId, file, bannerHash) {
        return _ref.apply(this, arguments);
    };
}();
var withdrawSponsorApproval = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/alerts/".concat(alertId, "/story/sponsor-approval"))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        fetchStory(alertId)
                    ];
            }
        });
    });
    return function withdrawSponsorApproval(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// The proof is private and the API takes a bearer token, so a plain link would not open it.
var fetchSponsorProof = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/".concat(alertId, "/story/sponsor-approval/proof"), {
                            responseType: "blob"
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function fetchSponsorProof(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStorySponsors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _state, state, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _state = ref.state, state = _state === void 0 ? "all" : _state, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/story-sponsors", {
                            params: {
                                state: state,
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state1.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchStorySponsors() {
        return _ref.apply(this, arguments);
    };
}();
var fetchProfileBySlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/profiles/slug/".concat(encodeURIComponent(slug)))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchProfileBySlug(slug) {
        return _ref.apply(this, arguments);
    };
}();
// The story's one offer at publication: { choice: 'faq' } or { choice: 'full', pricePence }.
// Resolves { sent, story, research }; sent is false when the email failed and Send may retry.
var sendStoryOffer = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, offer) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/offer"), offer)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function sendStoryOffer(alertId, offer) {
        return _ref.apply(this, arguments);
    };
}();
var publishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/publish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function publishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var unpublishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/unpublish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function unpublishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Out of Google (noindex,follow, off the sitemaps) or back in; the page stays live either way.
var setAlertNoindex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, noindex) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/noindex"), {
                            noindex: noindex
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function setAlertNoindex(alertId, noindex) {
        return _ref.apply(this, arguments);
    };
}();
var markRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        var exclusiveUntil;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    exclusiveUntil = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/raw"), {
                            exclusiveUntil: exclusiveUntil
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Back to the top of the Raws archive, without touching the alert's own dates.
var markReraw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/reraw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markReraw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// "Not a Raw": out of the archive if it was in it, and out of the review queue.
var markNotRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/alerts/".concat(alertId, "/raw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markNotRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRaws = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, q, tag, _page, page, _size, size, params;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, q = ref.q, tag = ref.tag, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    params = {
                        page: page,
                        size: size
                    };
                    if (q) params.q = q;
                    if (tag) params.tags = tag;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws", {
                            params: params
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRaws() {
        return _ref.apply(this, arguments);
    };
}();
var fetchRawQueue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws/queue", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRawQueue() {
        return _ref.apply(this, arguments);
    };
}();
var fetchNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size, profile, author;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size, profile = ref.profile, author = ref.author;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/news", {
                            params: {
                                page: page,
                                size: size,
                                profile: profile,
                                author: author
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchNews() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAuthors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/authors")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchAuthors() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 69561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Raws_wrapper__oJ1uV","head":"Raws_head__mAUeS","authorStories":"Raws_authorStories__2WVQQ","intro":"Raws_intro__krOhY","reviewLink":"Raws_reviewLink__yKDmz","adminSection":"Raws_adminSection__KcDt2","adminBlock":"Raws_adminBlock__D1z_n","adminTool":"Raws_adminTool__kc5sb","search":"Raws_search__i6xdv","clear":"Raws_clear__KW_XF","srOnly":"Raws_srOnly__DRhZh","count":"Raws_count__WAAX_","empty":"Raws_empty__j0D6T","error":"Raws_error__4gr7n","list":"Raws_list__ciMDF","item":"Raws_item__35M_h","reviewItem":"Raws_reviewItem__hZKE9","reviewActions":"Raws_reviewActions__82iHx","tabs":"Raws_tabs__yAUCg","coverageFields":"Raws_coverageFields__RUxA4","itemMeta":"Raws_itemMeta__Vt4x8","reraw":"Raws_reraw__nJOzN","itemSource":"Raws_itemSource__6mlk8","thin":"Raws_thin__y31qG","itemTitle":"Raws_itemTitle__aVsPX","itemTitleRan":"Raws_itemTitleRan__pNeQL","ran":"Raws_ran__uhYf1","ranLabel":"Raws_ranLabel__XgfnS","excerpt":"Raws_excerpt__BQRVb","tags":"Raws_tags__IZx_5","tagOverflow":"Raws_tagOverflow__w_e6K","tagsExpanded":"Raws_tagsExpanded__gdHJs","pager":"Raws_pager__m_zW8","bankButton":"Raws_bankButton__9pAek","bankedBefore":"Raws_bankedBefore__ruAAO","myBanks":"Raws_myBanks__3e7HR","unbank":"Raws_unbank__M3fQC","bankStats":"Raws_bankStats__p6_7V","bankStat":"Raws_bankStat__4d_rm"};

/***/ })

}]);